var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.503 13.623a3.206 3.206 0 01-4.526 0 3.206 3.206 0 010-4.526l2.83-2.827a3.2 3.2 0 014.344-.173.602.602 0 01-.782.915 1.982 1.982 0 00-2.714.106L1.826 9.946c-.79.79-.79 2.037 0 2.828.79.79 2.038.79 2.828 0l2.687-2.687a.6.6 0 11.849.848l-2.687 2.688zm5.091-5.092a3.201 3.201 0 01-4.344.173.602.602 0 11.782-.915c.79.68 1.96.648 2.714-.106l2.828-2.829c.79-.79.79-2.037 0-2.828a1.983 1.983 0 00-2.828 0L7.059 4.713a.6.6 0 11-.849-.849l2.687-2.687a3.206 3.206 0 014.526 0 3.206 3.206 0 010 4.526l-2.83 2.827z",
    fill: "#093F46"
  })));
}

export default SvgIconLink;